/**
 * The founding-member chip. Extracted (Spec 18 confirm 5) so the member-home
 * header and Settings → Subscription render one identical treatment. Callers
 * control margin; the chip is an inline span.
 */
export function FounderChip({ number }: { number: number }) {
  return (
    <span className="inline-flex items-center gap-2 whitespace-nowrap rounded-sm border border-oxblood/40 bg-oxblood/5 px-3 py-1 font-sans text-xs uppercase tracking-[0.18em] text-oxblood">
      Founding Member #{number}
    </span>
  );
}
